const EMAIL_PATTERN = /[^\s@]+@[^\s@]+\.[^\s@]+/;

function devWarn(message: string): void {
  if (import.meta.env.DEV) {
    console.error(`[usage-telemetry sanitize] ${message}`);
  }
}

/** True when `value` looks like an email address. */
function looksLikeEmail(value: unknown): boolean {
  return typeof value === 'string' && EMAIL_PATTERN.test(value);
}

/**
 * Sanitizes a single identity field (an opaque id, never a name/email). Rejects
 * values that look like an email - identity fields such as a SHI employee id are
 * legitimately numeric, so no other pattern is applied here.
 */
export function sanitizeIdentityValue(field: string, value: string | undefined): string | undefined {
  if (value === undefined) return undefined;
  if (looksLikeEmail(value)) {
    devWarn(`identity.${field}: value rejected, looks like an email address`);
    return undefined;
  }
  return value;
}
